import analytics from 'scenes/common/analytics';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { getPaymentState } from '../redux/payment/selectors';
import { toErrorEvent, toViewLoadedEvent } from '../analytics/marshaller';

export enum AnalyticsEvent {
  VIEW_LOADED = 'View-loaded',
  VIEW_LOADED_ERROR = 'View-loaded-with-error',
  ERROR = 'Error',
}

const usePublishAnalyticsEvent = (
  desiredEvent: AnalyticsEvent
): ((uiMessage?: string) => void) => {
  const location = useLocation();
  const state = useSelector(getPaymentState);
  switch (desiredEvent) {
    case AnalyticsEvent.VIEW_LOADED:
      return () => analytics().pushEvent(toViewLoadedEvent(location, state));
    case AnalyticsEvent.VIEW_LOADED_ERROR:
      return () =>
        analytics().pushEvent(toViewLoadedEvent(location, state, true));
    case AnalyticsEvent.ERROR:
      return (uiMessage?: string) =>
        analytics().pushEvent(toErrorEvent(location, state, uiMessage));
    default:
      return () => {};
  }
};

export default usePublishAnalyticsEvent;
